import React, { useState } from "react";
import * as S from "./VideoTutorialSection.style";
import Separator from "../ui/Separator";

type Tutorial = {
  title: string;
  duration: string;
  videoUrl: string;
  thumbnail: string;
};

const tutorials: Tutorial[] = [
  {
    title: "Welcome to Dropshiptool",
    duration: "1:22",
    videoUrl: "/videos/welcome.mp4",
    thumbnail: "/thumbnails/welcome.png",
  },
  {
    title: "How to use Ad spy tool?",
    duration: "1:22",
    videoUrl: "/videos/ad-spy.mp4",
    thumbnail: "/thumbnails/ad-spy.png",
  },
  {
    title: "How to find trending products?",
    duration: "1:22",
    videoUrl: "/videos/trending-products.mp4",
    thumbnail: "/thumbnails/trending-products.png",
  },
  {
    title: "How to use competitor research?",
    duration: "1:22",
    videoUrl: "/videos/competitor-research.mp4",
    thumbnail: "/thumbnails/competitor-research.png",
  },
  {
    title: "How to use Sales tracker?",
    duration: "1:22",
    videoUrl: "/videos/sales-tracker.mp4",
    thumbnail: "/thumbnails/sales-tracker.png",
  },
  {
    title: "What is Product Database?",
    duration: "1:22",
    videoUrl: "/videos/product-database.mp4",
    thumbnail: "/thumbnails/product-database.png",
  },
];

const VideoTutorialSection: React.FC = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const selectedTutorial = tutorials[selectedIndex];

  return (
    <S.Container>
      <S.Title>Your Quick Walkthrough</S.Title>
      <S.Content>
        <S.VideoBox>
          {!isPlaying ? (
            <>
              <S.Thumbnail
                src={selectedTutorial.thumbnail}
                alt="Tutorial thumbnail"
              />
              <S.PlayButton onClick={() => setIsPlaying(true)}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </S.PlayButton>
            </>
          ) : (
            <S.VideoPlayer controls autoPlay>
              <source src={selectedTutorial.videoUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </S.VideoPlayer>
          )}
        </S.VideoBox>
        <Separator type="vertical" />
        <S.TutorialList>
          {tutorials.map((tutorial, index) => (
            <>
              <S.TutorialItem
                key={index}
                active={index === selectedIndex}
                onClick={() => {
                  setSelectedIndex(index);
                  setIsPlaying(false);
                }}>
                <S.TutorialText>
                  <img src="/video-icon.png" alt="Video icon" />
                  {tutorial.title}
                </S.TutorialText>
                <S.TutorialDuration>{tutorial.duration}</S.TutorialDuration>
              </S.TutorialItem>
              {index < tutorials.length - 1 && <Separator type="horizontal" />}
            </>
          ))}
        </S.TutorialList>
      </S.Content>
    </S.Container>
  );
};

export default VideoTutorialSection;
